mutation UserProfileApprovalCreate($input: UserProfileApprovalCreateInput!) {
  userProfileApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
